export default __webpack_public_path__ + "static/media/icon-email.a7f0ebf5.svg";